import renderRoutes from './utils';
import routes from './routes';

const RenderedRoutes = renderRoutes(routes);

export default RenderedRoutes;
